<template>
  <div class="wnds_search">

    <!-- banner图 -->
    <div class="wau_banner">
      <img src="../../../static/img/about_banner.838245b.png" >
    </div>

    <!-- 按条件搜索 -->
    <div class="search_box">
      <div class="search">
        <h1 class="search_left">姓氏</h1>
        <div class="search_right" v-for="(item,index) in letterList" :key="index">
          <span @click="checkedName(item,index)" :class="{active:categoryIndex==index}">{{item}}</span>
        </div>
      </div>
      <div class="search">
        <h1 class="search_left">领域</h1>
        <div class="search_right" v-for="(item,index) in fieldList" :key="index">
          <span @click="checkedField(item,index)" :class="{active:catIndex==index}">{{item}}</span>
        </div>
      </div>
      <!-- <div class="find" style="margin-top:-25px;">
         <h1 class="search_left" style="margin-right:15px;">搜索</h1>
        <el-input   placeholder="请输入您要查询的嘉宾名字" v-model="search" @keyup.enter.native="searchName()" style="width:300px;padding-top:30px;paddding-left:20px;"></el-input>
        <el-button @click="searchName()"  round style="margin-left:15px;">查询</el-button>
      </div> -->
    </div>

    <!-- 标题 -->
    <div class="titleBox">
      <h1 class="title0">读诗嘉宾</h1>
      <span class="line"> </span>
      <h1 class="title1">THE POEM FOR YOU</h1>
      <el-input   placeholder="搜索嘉宾名字" v-model="search" @keyup.enter.native="searchName()" style="width:300px;padding-top:54px;float:right;" class="searchInput">
         <i slot="prefix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>

    <!-- 嘉宾列表 -->
    <div class="guestList_box"  v-if="guestList.length > 0 ">
      <div class="guest_box" v-for="(item,index) in guestList" :key="index" @click="goProgram(item.gid)">
          <div class="guest_box_border"></div>
          <img :src="item.img_new" alt="">
          <h2>{{item.g_name}}</h2>
          <p>{{item.title}}</p>
      </div>
    </div>

    <el-alert
      title="暂无数据"
      type="info"
      description="别难过，TA在未来等你哦~"
      center
      closable
      @close="closeAlert"
      show-icon
      style="height:150px;"
      v-else>
    </el-alert>

    <!-- 分页 -->
    <div class="paging_box" id="paging_box" v-if="guestList.length > 0">
      <el-pagination
        layout="prev, pager, next"
        :current-page="currentPage"
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="pagesize"
        class="paging1">
      </el-pagination>
    </div>

  </div>
</template>

<script>
export default {
  name: "search",
  data() {
    return {
      letterList:["全部","A","B","C","D","E","F","G","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"],
      fieldList:["全部","政治","/","文化艺术","/","教育科技","/","语言艺术","/","演艺娱乐","/","体育","/","商业","/","用户"],
      guestList: [],
      currentPage: 1,
      pagesize:16,
			rowCount: 0,
      total: 0,
      name:'',
      field:'',
      categoryIndex:0,
      catIndex:0,
      goProGid:"",
      search:''
    };
  },
  created() {
    this.$parent.activeIndex = 'search'
    this.wnlSliderLastFn(this.currentPage, this.pagesize, "", "","");
  },
  methods:{
    wnlSliderLastFn(page,per,str,type_name,name_chart){
      this.axios.post(
        process.env.API_HOST + "/getGuestList",
        this.$qs.stringify({"page":page ,"per": per,"str": str,"type_name":type_name,"name_chart": name_chart})
      )
      .then(({data}) => {
        if (data && data.code === 201) {
          this.currentPage = data.msg.current
          this.pagesize = data.msg.rowCount
          this.total = data.msg.total
          this.guestList = data.msg.rows
        }
      })
      .catch(error => {
        this.$toast("网络错误，不能访问");
      });
    },
    handleCurrentChange:function(currentPage){
      this.currentPage = currentPage;
      this.wnlSliderLastFn(this.currentPage, this.pagesize, this.search, this.field,this.name)
    },
    checkedName (name,index) {
      this.currentPage = 1
      this.name = name
      this.categoryIndex = index;
      if (this.name === '全部') {
        this.name = ''
      }
      this.wnlSliderLastFn(this.currentPage, this.pagesize, this.search, this.field,this.name)
    },
    checkedField(field,index){
      this.currentPage = 1
      this.field = field
      this.catIndex = index;
      if (this.field === '全部') {
        this.field = ''
      }else if(this.field === '用户'){
        this.field = '大众'
      }else if(this.field == '商业'){
        this.field ='商业领袖'
      }else if(this.field == '体育'){
        this.field = '体育明星'
      }else if(this.field == '演艺娱乐'){
        this.field = '演艺人士'
      }else if(this.field == '教育科技'){
        this.field = '教育科学'
      }else if(this.field == '政治'){
        this.field = '政治人物'
      }
      this.wnlSliderLastFn(this.currentPage, this.pagesize, this.search, this.field,this.name)
    },
    goProgram(id){
      this.axios.post(
        process.env.API_HOST + "/getGusetPaogramId",
        this.$qs.stringify({"gid":id})
      )
      .then(({data}) => {
        if (data && data.code === 201) {
          this.goProGid = data.msg.n_program_id
        }
        this.$router.push({path:"/newsDetail?id="+ this.goProGid})
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
      })
    },
    searchName(){
      this.wnlSliderLastFn(this.currentPage, this.pagesize, this.search,this.field,this.name)
    },
    closeAlert () {
      this.search = ''
      this.wnlSliderLastFn(this.currentPage, this.pagesize, this.search, this.field,this.name)
    }
  },
  watch:{
    search(val){
      if(val == ""){
         this.wnlSliderLastFn(this.currentPage, this.pagesize, this.search, this.field,this.name)
      }
    }
  }
};
</script>

<style>
.el-input__inner{
  border-radius: 20px !important;
  height: 28px !important;
  line-height: 28px !important;
  border: 1px solid #999 !important;
  text-align: center;
  margin-right: 50px;
}
.el-input{
  margin-right: 20px;
}
.el-input__inner::-webkit-input-placeholder {
  /* WebKit browsers 适配谷歌 */
  color: #999 !important;    
}
.el-pager li.active{
  color: #8eb758;
}
.el-pager li:hover{
  color: #8eb758 !important;
}
.el-pager{
  color: #666;
}
.wnds_search{
  background: #f8f9fd ;
  display: inline-table;
	width: 100%;
}
.wau_banner,.wau_banner img {
  width: 100%;
  font-size: 0;
}
.search_box {
  width: 1140px;
  margin: 70px auto 0px;
}
.search_box .search_left {
  width: 120px;
  line-height: 44px;
  background: #8eb758;
  color: #fff;
  text-align: center;
  border-radius: 4px 4px 4px 4px;
  margin-bottom: 36px;
  display: inline-block;
  font-size: 20px;
  letter-spacing: 3px;
}
.search_right {
  display: inline-block;
  margin-left: 15px;
  font-size: 21px;
  color: #666666;
}
.search_right span {
  cursor: pointer;
}
.titleBox{
  width: 1140px;
  margin: 0 auto;
}
.title0 {
  display: inline-block;
  font-size: 26px;
  text-align: left;
  letter-spacing: 3px;
  font-weight: 400;
  margin-top: 54px;
  margin-bottom: 81px;
  margin-right: 18px;
}
.titleBox .title1{
  display: inline-block;
  color: #a7a6a6;
  font-size: 26px;
  margin-left: 18px;
  font-weight: 300;
  margin-top: 54px;
}
.titleBox .line{
  display: inline-block;
  width: 1px;
  height: 28px;
  border-right: 3px solid #a7a6a6;
  margin-bottom: -5px;
}
.el-input__icon {
    margin-top: 26px;
}
.guestList_box {
  width: 1140px;
  margin:  0 auto;
  display: -webkit-flex;
  display: flex;
  flex-wrap:wrap;
  justify-content:flex-start;
}
.guest_box {
  cursor: pointer;
  width: 268px;
  height: 280px;
  margin-right: 15px;
  margin-bottom: 20px;
  color: #5a5a5a;
  text-align: center;
  background: #fff;
  /* border: 1px solid #ddddde; */
}
.guest_box:hover{
  -webkit-box-shadow: 0px 0px 50px -10px #cccccc;
  box-shadow: 0px 0px 50px -10px #cccccc;
}
.guest_box_border {
    display: none;
    width: 152px;
    height: 4px;
    margin-left: -76px;
    background-color: #a7c07e;
    position: relative;
    top: -3px;
    left: 50%;
    z-index: 10;
}
.guest_box:hover .guest_box_border {
  display: block;
}
.guest_box img {
  width: 142px;
  height: 142px;
  border-radius: 50%;
  margin-top: 25px;
}
.guest_box h2{
  font-size: 20px;
  margin-top:20px;
}
.guest_box p{
  font-size: 14px;
  margin: 10px;
  line-height: 16px;
}
.paging1{
  text-align: center;
  line-height: 120px;
  margin-top: 40px;
}

.active {
 color:#8ca764 !important;
}
</style>






// WEBPACK FOOTER //
// src/components/page/Search.vue